import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

interface DirectionProviderProps {
  children: React.ReactNode;
}

export default function DirectionProvider({
  children,
}: DirectionProviderProps) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    // Set document direction and language
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language, isRTL]);

  return (
    <div dir={isRTL ? 'rtl' : 'ltr'} className={isRTL ? 'rtl' : 'ltr'}>
      {children}
    </div>
  );
}
